/**
 * Mobile-only dot pagination for .pvs-lq-ad-triple horizontal scroll (Ad 1, Ad 2, …).
 */
(function () {
  const MQ = '(max-width: 768px)';

  function initAdGallery(root) {
    if (root.dataset.pvsLqAdGalleryInit === '1') return;
    root.dataset.pvsLqAdGalleryInit = '1';

    const track = root.querySelector('.pvs-lq-ad-triple__track');
    const dotsHost = root.querySelector('.pvs-lq-ad-triple__dots');
    if (!track || !dotsHost) return;

    const slides = track.querySelectorAll('.pvs-lq-ad-triple__slide');
    const mq = window.matchMedia(MQ);
    let dotButtons = [];
    let onScrollBound = null;

    function clearDots() {
      dotsHost.innerHTML = '';
      dotButtons = [];
      if (onScrollBound) {
        track.removeEventListener('scroll', onScrollBound);
        onScrollBound = null;
      }
    }

    function syncDots() {
      if (!mq.matches || dotButtons.length === 0) return;
      const w = track.clientWidth;
      if (!w) return;
      const idx = Math.min(
        dotButtons.length - 1,
        Math.max(0, Math.round(track.scrollLeft / w))
      );
      dotButtons.forEach(function (btn, i) {
        btn.classList.toggle('is-active', i === idx);
        btn.setAttribute('aria-selected', i === idx ? 'true' : 'false');
      });
    }

    function buildDots() {
      clearDots();
      if (slides.length < 2) {
        dotsHost.setAttribute('hidden', '');
        return;
      }
      if (!mq.matches) {
        dotsHost.setAttribute('hidden', '');
        return;
      }

      dotsHost.removeAttribute('hidden');
      slides.forEach(function (_slide, i) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pvs-lq-ad-triple__dot' + (i === 0 ? ' is-active' : '');
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        btn.setAttribute('aria-label', 'View image ' + (i + 1) + ' of ' + slides.length);
        btn.addEventListener('click', function () {
          const w = track.clientWidth;
          track.scrollTo({ left: i * w, behavior: 'smooth' });
        });
        dotsHost.appendChild(btn);
        dotButtons.push(btn);
      });

      onScrollBound = function () {
        syncDots();
      };
      track.addEventListener('scroll', onScrollBound, { passive: true });
      syncDots();
    }

    function onMqChange() {
      buildDots();
    }

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', onMqChange);
    } else {
      mq.addListener(onMqChange);
    }

    window.addEventListener(
      'resize',
      function () {
        syncDots();
      },
      { passive: true }
    );

    buildDots();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-pvs-lq-ad-gallery]').forEach(initAdGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    initAll(evt.target);
  });
})();
